import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as assetType from './asset-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: assetType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.AssetType, string>
for (const enumEntryName in common.AssetType) {
  const potentialEnum =
    common.AssetType[enumEntryName as keyof typeof common.AssetType]
  if (common.AssetType.isAssetType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.AssetType.ALL.reduce(
  (prev, _assetType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_assetType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.AssetType.getEntry(_assetType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.AssetType as (typeof common.AssetType)[K] extends common.AssetType
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
